import { inject } from '@angular/core';
import { MobileDialogBackButtonService } from '@shared/mobile-dialog-back-button.service';
import { Subject } from 'rxjs';

export const MOBILE_OVERLAY_BACK_BUTTON_EXCLUDED_SELECTORS = ['#applicationSelect'];

export function isMobileOverlayBackButtonExcluded(element: Element): boolean {
  return MOBILE_OVERLAY_BACK_BUTTON_EXCLUDED_SELECTORS.some(
    selector => element.matches(selector) || element.closest(selector)
  );
}

export class MobileOverlayBackButtonHandler {
  // Always constructed in a directive field initializer, i.e. in an injection context.
  private readonly mobileDialogBackButton = inject(MobileDialogBackButtonService);
  private closed$: Subject<void> | null = null;

  public constructor(
    private readonly opts: {
      // Return true only while the overlay controlled by this handler is currently visible/open.
      isOverlayOpen: () => boolean;

      // Close the overlay when Back is pressed; should be idempotent and safe to call only while open.
      closeOverlay: () => void;

      // Enable the synthetic history behavior for the current device/control state; return false to opt out.
      shouldHandleBackButton: () => boolean;
    }
  ) {}

  public destroy(): void {
    this.handleClosed();
  }

  public handleOpened(): void {
    if (this.closed$ || !this.opts.shouldHandleBackButton()) {
      return;
    }

    this.closed$ = new Subject<void>();
    this.mobileDialogBackButton.registerOpenOverlay({
      isOpen: this.opts.isOverlayOpen,
      close: () => {
        this.opts.closeOverlay();
        return true;
      },
      closed: this.closed$,
    });
  }

  public handleClosed(): void {
    this.closed$?.next();
    this.closed$?.complete();
    this.closed$ = null;
  }
}
